import React, { useContext } from 'react';
import { Button, Grid, Typography } from '@mui/material';
import firebase from 'firebase/app';
import { Link } from 'react-router-dom';
import { UIContext } from '../../Unknown/UIContext';
import logo from '../assets/logo.svg';
import bgImage from '../assets/login-bg.svg';
import SignInForm from '../SignInForm';
import 'firebase/auth';

interface SignInTypes {
  email: string;
  password: string;
}

const SignInScreen: React.FC = () => {
  const { setAlert } = useContext(UIContext);
  async function handleSubmitChange(
    values: SignInTypes,
    setSubmitting: (isSubmitting: boolean) => void,
  ) {
    await setSubmitting(true);
    try {
      await firebase
        .auth()
        .signInWithEmailAndPassword(values.email, values.password)
        .then(() => {
          setAlert({
            show: true,
            severity: 'success',
            message: 'Sign in!',
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'center',
            },
          });
        });
    } catch (error) {
      const errorMessage =
        error instanceof Error ? error.message : 'Something went wrong';
      setAlert({
        show: true,
        severity: 'error',
        message: errorMessage,
      });
    }
    await setSubmitting(false);
  }
  return (
    <>
      <Grid container height="100vh">
        <Grid
          item
          xs={6}
          sx={{
            background: `url(${bgImage}) no-repeat center`,
            backgroundSize: 'cover',
            boxSizing: 'border-box',
          }}
        />
        <Grid sx={{ textAlign: 'center', paddingTop: '10%' }} item xs={6}>
          <img src={logo} alt="logo" />
          <Typography mb={10} variant="h2">
            Login
          </Typography>
          <SignInForm handleSubmitChange={handleSubmitChange} />
          <Typography pt={4} variant="h5">
            Dont have an account?
          </Typography>
          <Button
            sx={{ marginTop: '20px', fontSize: '16px' }}
            component={Link}
            to="/register"
            color="primary"
          >
            Register
          </Button>
        </Grid>
      </Grid>
    </>
  );
};

export default SignInScreen;
